module.exports = __webpack_public_path__ + "img/lantern1.1e0e1167.png";